export default {
      MyOrders: 'Active Order|Active Orders',
      MyOrders_no_body: 'Active Order',
};
